/* eslint-disable jsx-a11y/anchor-is-valid */
import {SnackbarProvider} from 'notistack'
import {useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {ChangeRoomFiltersModel, ChangeRoomModel} from '../../../../models/change-rooms.model'
import {getBookingsChangeRoomsService} from '../../../../services/change-rooms.service'
import {ModalConfirmChangeRoom} from '../Modals/ModalConfirmChangeRoom'

interface Props {
  mainFilters: ChangeRoomFiltersModel
  hasClicked: number
}

const TableChangeRooms = ({mainFilters, hasClicked}: Props) => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()
  const [showModal, setShowModal] = useState(false)
  const [bookingToEdit, setBookingToEdit] = useState()

  // const [guest, setGuest] = useState<SelectOption[]>([])

  const getBookings = async () => {
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await getBookingsChangeRoomsService({
        CompaniaId: mainFilters?.CompaniaId,
        ClienteId: mainFilters?.ClienteId,
        SiteId: mainFilters?.SiteId,
        CampamentoId: mainFilters?.CampamentoId,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        // ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleChangeRoom = (item: any) => {
    setBookingToEdit(item)
    setShowModal(true)
  }

  const handleShowDetail = (item: any) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'detail-change-rooms',
      },
      idToDelete: '',
      idToEdit: item.ReservaCamaId,
    }
    changeCurrentTabItem(obj)
  }

  // useEffect(() => {
  //   if (Object.keys(searchValues).length === 0) {
  //     // getChekings()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchValues])

  const columns: Column<ChangeRoomModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Habitación'
            //  name='CodigoHabitacion'
            //  searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cama'
            // name='CodigoCama'
            //  searcheable
          />
        ),
        accessor: 'CodigoCama',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de cama' />,
        accessor: 'CamaTipo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            // searcheable
            // number
          />
        ),
        accessor: 'CodigoReserva',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc.' />,
        accessor: 'TipoDocDescripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Documento' />,
        accessor: 'NroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huesped'
            // name='HuespedId'
            // selecteable
            // data={guest}
          />
        ),
        accessor: 'HuespedDescripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tip. Empresa' />,
        accessor: 'TipoEmpresa',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Inicio'
            // name='FechaIni'
            // dateable
          />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Fin'
            // name='FechaFin'
            //  dateable
          />
        ),
        accessor: 'FechaFin',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
        accessor: 'Estado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cambiar' />,
        id: 'action',
        Cell: ({...props}) =>
          isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleChangeRoom(props.row.original)}
            >
              <a
                href='#'
                className='btn btn-icon btn-link btn-color-gray-500 btn-active-color-success btn-sm'
              >
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-2' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Huesped' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('VER') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a
                href='#'
                className='btn btn-icon btn-link btn-color-gray-500 btn-active-color-success btn-sm'
              >
                <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-2' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [],
  )

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      content: {
        ...currentTabItem.content,
      },
      idToDelete: '',
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
    // return () => {
    //   clearSearchValues()
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   if (updateTable) {
  //     clearSelected()
  //     // getChekings()
  //     setUpdateTable(false)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [updateTable])

  useEffect(() => {
    setLoading(loading)
    // setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (hasClicked > 0) {
      getBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasClicked, pagination.currentPage])

  return (
    <>
      {loading ? <KTableLoading title='Cargando...' /> : null}
      <KTable data={data} columns={columns} />
      {showModal ? (
        <ModalConfirmChangeRoom
          show={showModal}
          setShow={setShowModal}
          bookingToEdit={bookingToEdit}
          getBookings={getBookings}
          camp={mainFilters?.CampamentoId}
        />
      ) : (
        <></>
      )}
      <SnackbarProvider />
    </>
  )
}

const TableChangeRoomsWrapper = ({mainFilters, hasClicked}: Props) => {
  return (
    <KTableProvider>
      <TableChangeRooms mainFilters={mainFilters} hasClicked={hasClicked} />
    </KTableProvider>
  )
}

export {TableChangeRoomsWrapper}
